import React, { useCallback, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { format as formatDate } from 'date-fns';
import { Box, Flex, Heading, Button, Text } from 'roo-ui/components';
import { useDialog } from 'components/Dialog';
import { getDateChangeMessaging } from 'store/ui/uiSelectors';
import { clearDateChangeMessaging } from 'store/ui/uiActions';
import { DISPLAY_DATE_FORMAT } from 'config';
import { useDataLayer } from 'hooks/useDataLayer';

const UnintendedDateChangeDialog = () => {
  const { openDialog, closeDialog, Dialog } = useDialog();
  const { isVisible, checkIn, checkOut } = useSelector(getDateChangeMessaging) || {};
  const dispatch = useDispatch();
  const { emitInteractionEvent } = useDataLayer();

  const closeDialogHandler = useCallback(() => {
    emitInteractionEvent({ type: 'Date Change Pop Up', value: 'Continue Button Selected' });
    dispatch(clearDateChangeMessaging());
  }, [dispatch, emitInteractionEvent]);

  useEffect(() => {
    if (isVisible) {
      openDialog();
      emitInteractionEvent({ type: 'Date Change Pop Up', value: 'Pop Up Displayed' });
    } else {
      closeDialog();
    }
  }, [closeDialog, emitInteractionEvent, isVisible, openDialog]);

  return isVisible ? (
    <Dialog maxWidth="450px">
      <Flex flexDirection="column" alignItems="center" data-testid="date-change-modal-content">
        <Heading.h3>Your travel dates have changed</Heading.h3>
        <Box textAlign="center">
          <Text color="greys.steel" fontSize="sm">
            Please review your dates and continue.
          </Text>
        </Box>
        <Flex border={1} borderColor="greys.alto" mt={4} p={6} flexDirection="column" width="100%">
          <Flex mb={2}>
            <Box width="50%">
              <Text>Check-in date</Text>
            </Box>
            <Box width="50%">
              <Text fontWeight="bold" data-testid="check-in">
                {formatDate(checkIn, DISPLAY_DATE_FORMAT)}
              </Text>
            </Box>
          </Flex>
          <Flex>
            <Box width="50%">
              <Text>Check-out date</Text>
            </Box>
            <Box width="50%">
              <Text fontWeight="bold" data-testid="check-out">
                {formatDate(checkOut, DISPLAY_DATE_FORMAT)}
              </Text>
            </Box>
          </Flex>
        </Flex>
        <Flex justifyContent="center" mt={8}>
          <Button onClick={closeDialogHandler} variant="primary" data-testid="continue-button">
            Continue
          </Button>
        </Flex>
      </Flex>
    </Dialog>
  ) : null;
};

export default UnintendedDateChangeDialog;
